import Canvas from 'components/Canvas/Canvas';
import LearningCenterModal from 'components/Modal/LearningCenterModal';
import LearningCenterPanel from 'components/Panel/LearningCenterPanel';
import LeftPanel from 'components/Panel/LeftPanel';
import RightPanel from 'components/Panel/RightPanel';
import UI from 'components/UI';
import { shallowEqual, useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { openCanvasLeft, openCanvasWidth } from 'redux/mode/util';
import Island from 'components/Island';
import * as S from './styles';

const Workspace = () => {
	const { panelsVisible, learningCenterState, islandLeft } = useSelector((r: RootReducer) => {
		const canvasLeft = openCanvasLeft(r.mode);
		const canvasWidth = openCanvasWidth(r.mode);
		return {
			panelsVisible: r.mode.panelsVisible,
			learningCenterState: r.mode.learningCenterState,
			islandLeft: canvasLeft + canvasWidth / 2, // Center between panels
		};
	}, shallowEqual);

	return (
		<>
			<S.Workspace>
				<Canvas />
				<UI />
			</S.Workspace>
			{panelsVisible && (
				<>
					<S.Panels>
						<S.LeftPanels>
							<LeftPanel />
						</S.LeftPanels>
						<S.RightPanels>
							<RightPanel />
						</S.RightPanels>
					</S.Panels>
				</>
			)}
			<S.Island left={islandLeft}>
				<Island />
			</S.Island>
			{(learningCenterState.currentVideo || learningCenterState.showOnboarding) && (
				<LearningCenterModal />
			)}
			{learningCenterState.panelVisible && <LearningCenterPanel />}
		</>
	);
};

export default Workspace;
